export enum AssessmentID {
  GEN_AI_SUITABILITY = "gen-ai-suitability",
}
